import $ from 'jquery'
import { Modify as OLModify } from 'ol/interaction'
import Tool from '../Tool'

import { toValidGeometry } from '../ol'

/**
 * Modify tool class
 *
 * @param {Object} config
 * @constructor
 */
export default class Modify extends Tool {
  constructor(config) {
    super()

    $.extend(this, config)

    this.ui.iconClass = 'fa fa-edit'

    this.interaction = new OLModify({
      features: this.select.getFeatures()
    })

    this.useSnap = true

    this.interaction.on('modifystart', this.api.draw.createTrigger())
    this.interaction.on('modifyend', this.api.draw.createTrigger())

    const onModifyComplete = this.api.draw.createTrigger()

    this.lastSelectedGeometry = null

    this.select.getFeatures().on('remove', e => {
      if (this.activated && e.element) {
        const feature = e.element
        let reverted = false
        try {
          if (
            feature &&
            (feature.getGeometry().getType() === 'Polygon' ||
              feature.getGeometry().getType() === 'MultiPolygon')
          ) {
            feature.setGeometry(toValidGeometry(feature.getGeometry()))
          }
        } catch (e) {
          console.error('Error creating valid geometry, reverting', e)
          feature.setGeometry(this.lastSelectedGeometry)
          reverted = true
        }

        onModifyComplete({
          type: 'modifycomplete',
          feature: feature,
          data: { reverted }
        })
        this.lastSelectedGeometry = null
      }
    })

    this.select.getFeatures().on('add', e => {
      if (this.activated && e.element) {
        const feature = e.element
        this.lastSelectedGeometry = feature.getGeometry().clone()
      }
    })
  }

  /**
   * Activate associated select control
   */
  activate() {
    super.activate()
    this.map.addInteraction(this.select)

    var texttoolInteraction = this.texttool.interaction
    if (texttoolInteraction) {
      this.map.addInteraction(texttoolInteraction)
    }
  }

  /**
   * Dectivate associated select control
   */
  deactivate() {
    this.select.getFeatures().clear()
    this.map.removeInteraction(this.select)
    super.deactivate()
  }
}
